import { useQuery } from '@tanstack/react-query'
import { CarePlan } from '../types/carePlan'
import { carePlanService } from '../services/carePlanService'
import { format } from 'date-fns'
import './CarePlanList.css'

interface CarePlanListProps {
  patientId: string
  onSelect?: (carePlan: CarePlan) => void
}

export function CarePlanList({ patientId, onSelect }: CarePlanListProps) {
  const { data: carePlans, isLoading, error } = useQuery<CarePlan[]>({
    queryKey: ['care-plans', patientId],
    queryFn: () => carePlanService.getAll(patientId),
  })

  if (isLoading) return <div className="care-plan-list-loading">Loading care plans...</div>
  if (error) return <div className="care-plan-list-error">Error loading care plans</div>
  if (!carePlans || carePlans.length === 0) {
    return <div className="care-plan-list-empty">No care plans found</div>
  }

  return (
    <div className="care-plan-list">
      {carePlans.map((plan) => (
        <div
          key={plan.id}
          className="care-plan-item"
          onClick={() => onSelect?.(plan)}
          role="button"
          tabIndex={0}
        >
          <div className="care-plan-header">
            <div className="care-plan-title">{plan.title}</div>
            <div className="care-plan-status">
              <span className={`status-badge status-${plan.status}`}>{plan.status}</span>
            </div>
          </div>
          {plan.description && <div className="care-plan-description">{plan.description}</div>}
          <div className="care-plan-meta">
            {plan.startDate && <span>Started: {format(new Date(plan.startDate), 'MMM dd, yyyy')}</span>}
            {plan.goals && plan.goals.length > 0 && (
              <span>{plan.goals.length} goal{plan.goals.length !== 1 ? 's' : ''}</span>
            )}
            {plan.interventions && plan.interventions.length > 0 && (
              <span>{plan.interventions.length} intervention{plan.interventions.length !== 1 ? 's' : ''}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
